import { render, staticRenderFns } from "./buy-me-a-coffee.vue?vue&type=template&id=764e02d7&scoped=true"
import script from "./buy-me-a-coffee.vue?vue&type=script&lang=js"
export * from "./buy-me-a-coffee.vue?vue&type=script&lang=js"
import style0 from "./buy-me-a-coffee.styl?vue&type=style&index=0&id=764e02d7&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764e02d7",
  null
  
)

export default component.exports